/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Directory_Ads_Book_CtaInputs */

const en_directory_ads_book_cta = /** @type {(inputs: Directory_Ads_Book_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Book — ${i?.total}`)
};

const zh_directory_ads_book_cta = /** @type {(inputs: Directory_Ads_Book_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预订 — ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Book — {total}" |
*
* @param {Directory_Ads_Book_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_book_cta = /** @type {((inputs: Directory_Ads_Book_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Book_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_book_cta(inputs)
	return zh_directory_ads_book_cta(inputs)
});
export { directory_ads_book_cta as "directory.ads.book_cta" }